export default __webpack_public_path__ + "static/media/star.5c581d42.svg";